import Action from '../Action'
import styles from './style.styl'
      
const ABMSendFrom = () =>
<Action onEditClick={() => { window.open("/accounts", "_blank") }}>
  <div className={styles.ABMSendFrom}>
    <p>This Welcome Message will send from the Account Owner. <a href="/accounts" target="_blank"> Go to accounts.</a></p>
  </div>
</Action>

export default ABMSendFrom



// WEBPACK FOOTER //
// ./src/scripts/components/playbook/components/WelcomeMessage/ABMSendFrom.js